export const ILLNESS = {
  nickname: 'PRODUCTS.ILLNESS.shortname',
  isHidden: true,
  lifeInsurance: true,
  icon:'illness'
};
